import React, { Fragment, useState } from "react";
import { useAuth } from "../context/AuthContext";
import ShiftAssociatedBookingElement from "./ShiftAssociatedBookingElement";
import ShiftShiftDetailsElement from "./ShiftShiftDetailsElement";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";

const ShiftReminder = ({ shift, onComplete, close = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          shift_id: shift?.id,
        },
      };
      const response = await authAxios().post(
        "/api/backoffice/shifts/resend_active_confirmation_notification",
        null,
        config,
      );

      const fetchConfig = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          shift_id: shift?.id,
        },
      };

      const shiftResponse = await authAxios().get(
        "/api/backoffice/shifts/" +
          (shift?.table === "shifts" ? "active" : "archive"),
        fetchConfig,
      );

      setLoading(false);
      onComplete(shiftResponse.data);
    } catch (err) {
      setLoading(false);
      console.log("error:");
      console.log(err);
    }
  };

  return (
    <Fragment>
      <div>
        <ShiftAssociatedBookingElement shift={shift} />
      </div>
      <div>
        <ShiftShiftDetailsElement shift={shift} />
      </div>

      <ButtonModalFormSaveClose
        saveName={"Send Reminder"}
        close={close}
        formSave={onSave}
        loading={loading}
      />
    </Fragment>
  );
};

export default ShiftReminder;
